import {
  Box, Stack
} from '@mui/material';
import { FC, memo } from 'react';

import DetailSummaries from './DetailSummaries';
import MonthlySummaries from './MonthlySummaries';

const KpiDashboardPresenter: FC = memo(() => (
  <>
    <title>実績参照</title>
    <Box p={1}>
      <Stack sx={{ marginTop: 1 }}>
        <MonthlySummaries />
      </Stack>
      <Stack sx={{ marginTop: 2 }}>
        <DetailSummaries />
      </Stack>
    </Box>
  </>
));

export default KpiDashboardPresenter;
